module.exports = __webpack_public_path__ + "img/bounty_hunter.ce1554ba.png";